export declare type PointerEventType =
	| "pointerover"
	| "pointerenter"
	| "pointerdown"
	| "pointermove"
	| "pointerup"
	| "pointercancel"
	| "pointerout"
	| "pointerleave"
	| "gotpointercapture"
	| "lostpointercapture";

export const POINTER_EVENT_TYPES: PointerEventType[] = [
	"pointerover",
	"pointerenter",
	"pointerdown",
	"pointermove",
	"pointerup",
	"pointercancel",
	"pointerout",
	"pointerleave",
	"gotpointercapture",
	"lostpointercapture"
];
